import { useContext } from "react"
import UserContext from "../contexts/UserContext/context"

export const usePermissions = () => {
  const { user } = useContext(UserContext)
  const { permissions } = user

  const checkPermission = (name: string, isInverted: boolean = false, section: string = 'trackwell') => {
    const permission = permissions?.[section]?.[name] ?? false
    return isInverted ? !permission : permission
  }

  return {
    checkPermission
  }
}
